<template>
    <div class="col-sm-12">
        <div class="card">
            <div class="profile-post">
                <div class="post-header" id="first-post-tour">
                    <div class="d-flex"><img class="img-thumbnail rounded-circle me-3" src="@/assets/images/user/7.jpg"
                            alt="Generic placeholder image">
                        <div class="flex-grow-1 align-self-center"><router-link to="/app/social-app">
                                <h5 class="user-name">Emay Walter</h5>
                            </router-link>
                            <h6>22 Hours ago</h6>
                        </div>
                    </div>
                    <div class="post-setting"><i class="fa fa-ellipsis-h"></i></div>
                </div>
                <div class="post-body">
                    <div class="img-container">
                        <div class="pictures my-gallery tour-image" itemscope="">
                            <div v-for="(src, index) in items" :key="index" class="" @click="() => showImg(index)" >
                                <img :src="src" class="img-fluid rounded">
                                </div>
                                <vue-easy-lightbox :index="index" :visible="visible" :imgs="items" @hide="handleHide" ></vue-easy-lightbox>
                        </div>
                    </div>
                    <div class="post-react mt-4">
                        <ul>
                            <li><img class="rounded-circle" src="@/assets/images/user/3.jpg" alt=""></li>
                            <li><img class="rounded-circle" src="@/assets/images/user/5.jpg" alt=""></li>
                            <li><img class="rounded-circle" src="@/assets/images/user/1.jpg" alt=""></li>
                        </ul>
                        <h6>+5 people react this post</h6>
                    </div>
                    <p>Dressing is a way of life. My customers are successful working women. I want people to be afraid of
                        the women I dress. Age is something only in your head or a stereotype. Age means nothing when you
                        are passionate about something. There has to be a balance between your mental satisfaction and the
                        financial needs of your company.</p>
                    <ul class="post-comment">
                        <li>
                            <label><a href="javascript:void(0)"><vue-feather
                                        type="heart"></vue-feather>&nbsp;&nbsp;Like<span
                                        class="counter">50</span></a></label>
                        </li>
                        <li>
                            <label><a href="javascript:void(0)"><vue-feather
                                        type="message-square"></vue-feather>&nbsp;&nbsp;Comment<span
                                        class="counter">70</span></a></label>
                        </li>
                        <li>
                            <label><a href="javascript:void(0)"><vue-feather
                                        type="share"></vue-feather>&nbsp;&nbsp;share<span
                                        class="counter">20</span></a></label> 
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'post1Page',
    data() {
        return {
            visible: false,
            items: [
                 require(`@/assets/images/user-profile/post1.jpg`),
               ],
        }
    },
    methods: {
      showImg (index) {
        this.index = index
        this.visible = true
      },
      handleHide () {
        this.visible = false
      }
    }
}
</script>